export const STORE_PHONE = "(332) 333-6412";

export const GIFT_BOX_SKU = "990000007";

export const ADDTHIS_ID = 'ra-5f4ec39268f6acd2';

export const FREE_SHIPPING_AMOUNT = 49.00;

export const EXTEND_SKU = ';xtd;';

export const BOPUS_SHIPPING_DESCRIPTION = 'Zgallerie (BOPS)'
export const FREE_SHIPPING_DESCRIPTION = "Free Shipping"
export const STANDARD_SHIPPING_DESCRIPTION = "Zgallerie (Standard)"
export const STANDARD_PLUS_SHIPPING_DESCRIPTION = "Zgallerie (Standard Plus)"

export const PARKY_CREDIT_CARD_TRANSACTION_METHOD = 'Credit Card'
export const PARKY_PAYPAL_TRANSACTION_METHOD = 'PayPal'

export const BRAND = 'One Kings Lane'
export const PLP_Items_Per_Page = 60
export const FOOTER_SECTIONS = [
  {
    heading: 'Our Company',
    links: [{
      name: 'About Us',
      href: '/about-us',
    },
    {
      name: 'Blog',
      href: 'https://blog.onekingslane.com/',
    },
    {
      name: 'Careers',
      href: '/careers',
    }]
  },
  {
    heading: 'Customer Care',
    links: [
      {
        name: 'Returns',
        href: 'https://returns.narvar.com/okl/returns',
      },
      {
        name: 'Order Status',
        href: '/order-status',
      }, {
        name: 'FAQ',
        href: '/faq'
      },
      {
        name: 'Return Policy',
        href: '/faq/#returns-exchange',
      },
      {
        name: 'Shipping and Delivery',
        href: '/faq/#shipping-delivery',
      }, 
      // {
      //   name: 'Gift Cards',
      //   href: 'https://www.onekingslane.com/ancillary/giftcard.do',
      //   type: 'link',
      // },
      {
        name: 'Request a Swatch',
        href: '/swatch-request',
      },
      {
        name: 'Contact Us',
        href:'/contact-us',
      }
    ]
  },
  {
    heading: 'Resources',
    links: [{
      name: 'To the Trade',
      href: '/to-the-trade',
    },
      {
        name: 'Interior Design Services',
        href: '/design-services',
      },
      {
        name: 'Affiliates',
        href: '/affiliates-apply-now',
      },
      {
        name: 'Farrow & Ball',
        href: '/farrow-ball',
      },
      // {
      //   name: 'Protection Plans',
      //   href: 'https://www.onekingslane.com/c/warranty.do?ref=footer',
      // }
    ]
  }
]
